import {createStyles} from '@mantine/core';

export const FLOWCHART_ICON_BUTTON_PROPS = {
  // Intentionally use Mantine's built-in `filled` variant rather than our variants (primary,
  // secondary, tertiary, warn, ghost) because we want a dark grey button
  variant: 'filled' as const,
  color: 'gray' as const,
  size: 'md' as const,
  compact: true,
};

export const useFlowchartIconButtonStyles = createStyles(() => ({
  root: {
    padding: 10,
    width: 36,
    height: 36,
  },
}));
